"use client"
import { useEffect, useState } from "react"
import { Button } from "@/components/fun-ui/Button"
import { XIcon } from "@/components/fun-ui/icons";
import Link from "next/link";
import { type BrowserCompatibilityStatus, useBrowserCompatibility } from "@/hooks/useBrowser";

export function BrowserCompatibilityTip({ status }: { status: BrowserCompatibilityStatus }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(status !== 'supported');
  }, [status])

  if (!open) {
    return <></>;
  }
  return (
    <div className="bg-[#ECF2FF]/95 w-full sticky md:top-[71px] top-[100px] z-40">
      <div className="container p-2.5 flex items-center justify-between relative">
        <div className="flex-1 text-center">
          {status === 'unknown' ? '无法确认当前浏览器的兼容性，部分功能可能不可用，建议使用' : 'Findin 暂不支持你的浏览器使用，使用'}&nbsp;
          <Link className="text-primary hover:underline " href="/browsers">推荐浏览器</Link>
          &nbsp;访问可获得最佳体验
        </div>
        <Button onClick={() => setOpen(false)} className="h-auto py-0" variant="link"><XIcon /></Button>
      </div>
    </div>
  );
}

export function SiteBrowserTip() {
  const status = useBrowserCompatibility();
  return <BrowserCompatibilityTip status={status} />;
}
